/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Player } from './Player';
import {
    PlayerFromJSON,
    PlayerFromJSONTyped,
    PlayerToJSON,
} from './Player';
import type { PamPlayerVerificationSummary } from './PamPlayerVerificationSummary';
import {
    PamPlayerVerificationSummaryFromJSON,
    PamPlayerVerificationSummaryFromJSONTyped,
    PamPlayerVerificationSummaryToJSON,
} from './PamPlayerVerificationSummary';
import type { PamPlayerAccountSummary } from './PamPlayerAccountSummary';
import {
    PamPlayerAccountSummaryFromJSON,
    PamPlayerAccountSummaryFromJSONTyped,
    PamPlayerAccountSummaryToJSON,
} from './PamPlayerAccountSummary';
import type { PlayerDetailsResponse } from './PlayerDetailsResponse';
import {
    PlayerDetailsResponseFromJSON,
    PlayerDetailsResponseFromJSONTyped,
    PlayerDetailsResponseToJSON,
} from './PlayerDetailsResponse';

/**
 * 
 * @export
 * @interface PlayerWithPAMDetails
 */
export interface PlayerWithPAMDetails {
    /**
     * 
     * @type {PamPlayerVerificationSummary}
     * @memberof PlayerWithPAMDetails
     */
    verification?: PamPlayerVerificationSummary | null;
    /**
     * 
     * @type {PamPlayerAccountSummary}
     * @memberof PlayerWithPAMDetails
     */
    account?: PamPlayerAccountSummary | null;
    /**
     * 
     * @type {PlayerDetailsResponse}
     * @memberof PlayerWithPAMDetails
     */
    details: PlayerDetailsResponse;
    /**
     * 
     * @type {Player}
     * @memberof PlayerWithPAMDetails
     */
    player: Player;
}

/**
 * Check if a given object implements the PlayerWithPAMDetails interface.
 */
export function instanceOfPlayerWithPAMDetails(value: object): value is PlayerWithPAMDetails {
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('player' in value) || value['player'] === undefined) return false;
    return true;
}

export function PlayerWithPAMDetailsFromJSON(json: any): PlayerWithPAMDetails {
    return PlayerWithPAMDetailsFromJSONTyped(json, false);
}

export function PlayerWithPAMDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerWithPAMDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'verification': json['verification'] == null ? undefined : PamPlayerVerificationSummaryFromJSON(json['verification']),
        'account': json['account'] == null ? undefined : PamPlayerAccountSummaryFromJSON(json['account']),
        'details': PlayerDetailsResponseFromJSON(json['details']),
        'player': PlayerFromJSON(json['player']),
    };
}

export function PlayerWithPAMDetailsToJSON(value?: PlayerWithPAMDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'verification': PamPlayerVerificationSummaryToJSON(value['verification']),
        'account': PamPlayerAccountSummaryToJSON(value['account']),
        'details': PlayerDetailsResponseToJSON(value['details']),
        'player': PlayerToJSON(value['player']),
    };
}

